<template>
  <div class="section swiper-activity">
    <div class="swiper-activity__wrap">
      <div class="swiper-activity__media">
        <div v-if="cards.length > 1" class="swiper-activity__controls">
          <button class="swiper-image__control-button -left" @click="previousCard">
            <Icon id="arrow" />
          </button>

          <button class="swiper-image__control-button" @click="nextCard">
            <Icon id="arrow" />
          </button>
        </div>

        <Swiper
          :slides-per-view="1"
          :allow-touch-move="true"
          :simulate-touch="true"
          :grab-cursor="true"
          class="swiper-activity__swiper"
          @swiper="setSwiper"
          @slideChange="onSlideChange"
        >
          <SwiperSlide v-for="(item, key) in cards" :key="`activity-${key}`">
            <div
              class="swiper-activity__img"
              :style="{
                backgroundImage: `url(${item.image?.lg || 'https://placehold.co/500x500'})`,
              }"
            />
          </SwiperSlide>
        </Swiper>

        <div v-if="cards.length > 1" class="swiper-activity__paging">
          <div
            v-for="(item, key) in cards"
            :key="key"
            class="swiper-activity__paging-item"
            :class="{ '-active': key === currentCard }"
            @click="goToCard(key)"
          />
        </div>
      </div>

      <transition name="fade-fast" mode="out-in">
        <div class="swiper-activity__content" :key="`content-${currentCard}`">
          <h2 class="section__title">
            {{ card.title }}
          </h2>

          <template v-for="(item, key) in card.description" :key="key">
            <div v-if="item.flexLayout === 'richtext'" v-html="item.content" class="wysiwyg" />

            <a
              v-if="item.flexLayout === 'button'"
              :key="key"
              :href="item.btn_link"
              target="_blank"
              class="button -right wysiwyg__button"
            >
              {{ item.btn_text }}

              <div class="button__icon">
                <Icon id="arrow" />
              </div>
            </a>
          </template>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'

import Icon from '@/components/global/Icon.vue'

export default {
  name: 'SectionSwiperActivity',

  components: {
    Icon,
    Swiper,
    SwiperSlide,
  },

  props: {
    cards: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      currentCard: 0,
      swiperInstance: null,
    }
  },

  computed: {
    card() {
      return this.cards[this.currentCard]
    },
  },

  methods: {
    setSwiper(swiper) {
      this.swiperInstance = swiper
    },

    onSlideChange(swiper) {
      this.currentCard = swiper.activeIndex
    },

    previousCard() {
      const index = this.currentCard === 0 ? this.cards.length - 1 : this.currentCard - 1

      this.goToCard(index)
    },

    nextCard() {
      const index = this.currentCard === this.cards.length - 1 ? 0 : this.currentCard + 1

      this.goToCard(index)
    },

    goToCard(index) {
      this.currentCard = index

      if (this.swiperInstance) {
        this.swiperInstance.slideTo(index)
      }
    },
  },
}
</script>
